import { h } from 'preact';
import LocatorIcon from 'utils/icon/icon-locator.svg';
import AccountIcon from 'utils/icon/icon-account.svg';
import GiftCardIcon from 'utils/icon/icon-gift-card.svg';
import { useMemo } from 'preact/hooks';
import useCurrentStore from 'utils/current-store';
import useResponsive from 'utils/responsive';
import { isMelanieLyne } from 'utils/helpers';
import RewardBalance from './reward-balance';

const HeaderTop = (props) => {

  const {
    onlyIcons,
    customer: customerData,
    containerClass,
    giftCardEnabled
  } = props;

  const userSavedStore = useCurrentStore();
  const { breakPoint } = useResponsive();

  const customer = useMemo(() => {
    if (customerData?.userName) {
      return (
        <div>
          <div
            className="body-3 lg:body-6"
            dangerouslySetInnerHTML={{
              __html: window.TMW.Strings.account.greetingName.replace(
                '{{customer}}',
                customerData?.userName,
              ),
            }}
          ></div>
          <RewardBalance />
        </div>
      );
    }
    return (
      <div>
        <div className="body-3 lg:body-6">
          {window.TMW.Strings.account.myAccount}
        </div>
        <div
          className="body-6 text-subdued"
          dangerouslySetInnerHTML={{
            __html: window.TMW.Strings.account.signIn,
          }}
        ></div>
      </div>
    );
  }, [customerData?.userName]);

  const storeName = useMemo(() => {
    if (userSavedStore) {
      if (
        ['tablet', 'lg'].includes(breakPoint) &&
        userSavedStore.name.length > 35
      ) {
        return `${userSavedStore.name.substring(0, 35)}...`;
      }
      return userSavedStore.name;
    }
    return '';
  }, [userSavedStore, breakPoint]);

  const giftCardUrl =
    `${Shopify.routes.root
    }pages/${window.TMW.Strings.giftCard?.pageUrl
    }`;

  if (!onlyIcons) {
    return (
      <div className={containerClass}>
        {giftCardEnabled && (
          <a
            className="flex lg:gap-12 gap-8 items-center max-tablet:hidden"
            href={giftCardUrl}
          >
            <GiftCardIcon className="flex-none w-24 lg:w-24 h-auto block" />
            <div>
              <div className="body-3 lg:body-6">
                {window.TMW.Strings.giftCard?.giftCards}
              </div>
              <div className="body-6 text-subdued">
                {window.TMW.Strings.giftCard?.offer}
              </div>
            </div>
          </a>
        )}
        <button
          className="flex lg:gap-12 gap-8 items-center text-left"
          onClick={() =>
            document.dispatchEvent(new CustomEvent('openStoreLocator'))
          }
        >
          <LocatorIcon className="flex-none w-24 lg:w-20 h-auto block" />
          {userSavedStore ? (
            <div>
              <div className="body-3 lg:body-6 line-clamp-2 tablet:line-clamp-none">
                {storeName}
              </div>
              <div
                className="body-6 text-subdued"
                dangerouslySetInnerHTML={{
                  __html: userSavedStore.status.summary,
                }}
              ></div>
            </div>
          ) : (
            <div>
              <div className="body-3 lg:body-6">
                {window.TMW.Strings.storeLocator.title}
              </div>
              <div className="body-6 text-subdued">
                {window.TMW.Strings.storeLocator.findStore}
              </div>
            </div>
          )}
        </button>
        <a
          className="flex lg:gap-12 gap-8 items-center"
          href={`${Shopify.routes.root}account`}
        >
          <AccountIcon className="flex-none w-24 lg:w-20  h-auto block" />
          {customer}
        </a>
      </div>
    );
  }

  return (
    <div className="gap-24 hidden tablet:flex items-center">
      {
        giftCardEnabled && (
          <a className="block" href={giftCardUrl}>
            <GiftCardIcon className="w-28 h-auto block" />
          </a>
        )
      }

      <button
        className="block"
        onClick={() =>
          document.dispatchEvent(new CustomEvent('openStoreLocator'))
        }
      >
        <LocatorIcon className="w-28 h-auto block" />
      </button>
      <a className="block" href={`${Shopify.routes.root}account`}>
        <AccountIcon className="w-28 h-auto block" />
      </a>
      {isMelanieLyne && <RewardBalance isMelanieLyne={isMelanieLyne} />}
    </div>
  );
};

export default HeaderTop;
